import axios from 'axios'

// import Vue from 'vue'
// let vue = new Vue()

var isProduction = process.env.NODE_ENV === 'production'
const serverName = isProduction ? '/museumcms/' : 'https://shmuseum.4dage.com/museumcms/'

axios.defaults.baseURL = serverName
axios.defaults.headers['X-Requested-with'] = 'XMLHttpRequest'

// 拦截请求，做登陆，或head处理
axios.interceptors.request.use(
  function (config) {
    // vue.$showLoading()
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        rnd: Math.random()
      }
    } else if (config.method === 'get') {
      config.params = {
        rnd: Math.random(),
        ...config.params
      }
    }
    return config
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 拦截返回，做错误统一处理
axios.interceptors.response.use(
  response => {
    let data = response.data
    let code = Number(response.data.status)
    // vue.$hideLoading()

    switch (code) {
      case -1:
        break
      case 4500:
       
        break
      case 5001:
        
        break
      case 5002:
        
        break
      case 500:
        
        break
      case 0:
        break
    }
    // tryHideFullScreenLoading()
    return data
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 500:
         
          break
      }
    }
    return Promise.reject(error)
  }
)

export { serverName, axios }
